// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2q9Im","select":"styles_select__3ABs5"};